import React, { useState, useRef , useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import { Upload, Eye, CheckCircle } from "lucide-react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
} from "react-bootstrap";

import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import Overview from "./Overview";

const Gadget = () => {
  const [models, setModels] = useState([]);
  const [variants, setVariants] = useState([]);
  const [isPincodeValid, setIsPincodeValid] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedManufacturer, setSelectedManufacturer] = useState("");
  const [listener, setListener] = useState(null);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    pincode: "",
    city: "",
    state: "",
    panDetails: "",
    insurer: "",
    gadgetModel: "",
    gadgetVariant: "",
    uniqueIdentifier: "",
    documentType: "",
    termsAccepted: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const mobileData = [
    {
      manufacturer: "Apple",
      models: [
        {
          name: "iPhone 15",
          variants: ["15", "15 Plus", "15 Pro", "15 Pro Max"],
        },
        {
          name: "iPhone 14",
          variants: ["14", "14 Plus", "14 Pro", "14 Pro Max"],
        },
        { name: "iPhone SE", variants: ["SE (3rd Gen)"] },
      ],
    },
    {
      manufacturer: "Samsung",
      models: [
        { name: "Galaxy S24", variants: ["S24", "S24+", "S24 Ultra"] },
        { name: "Galaxy Z Flip 5", variants: ["Flip 5"] },
        { name: "Galaxy Z Fold 5", variants: ["Fold 5"] },
        { name: "Galaxy A54", variants: ["A54 5G"] },
      ],
    },
    {
      manufacturer: "OnePlus",
      models: [
        { name: "OnePlus 12", variants: ["12"] },
        { name: "OnePlus 11", variants: ["11", "11R"] },
        { name: "OnePlus Nord CE", variants: ["Nord CE 3", "Nord CE 3 Lite"] },
      ],
    },
    {
      manufacturer: "Xiaomi",
      models: [
        { name: "Xiaomi 14", variants: ["14", "14 Pro", "14 Ultra"] },
        {
          name: "Redmi Note 13",
          variants: ["Note 13", "Note 13 Pro", "Note 13 Pro+"],
        },
        { name: "POCO F5", variants: ["F5", "F5 Pro"] },
      ],
    },
    {
      manufacturer: "Realme",
      models: [
        { name: "Realme 12 Pro", variants: ["12 Pro+", "12 Pro"] },
        { name: "Realme GT 2", variants: ["GT 2 Pro"] },
      ],
    },
    {
      manufacturer: "Oppo",
      models: [
        { name: "Oppo F19 Pro", variants: ["F19 Pro", "F19 Pro 5G"] },
        { name: "Oppo Reno 8", variants: ["Reno 8", "Reno 8 Pro"] },
        { name: "Oppo A78", variants: ["A78 5G"] },
      ],
    },
    {
      manufacturer: "Vivo",
      models: [
        { name: "Vivo X90", variants: ["X90", "X90 Pro", "X90 Pro+"] },
        { name: "Vivo V27", variants: ["V27 5G", "V27e"] },
        { name: "iQOO 11", variants: ["11 5G", "11 Pro"] },
      ],
    },
    {
      manufacturer: "Google",
      models: [
        { name: "Pixel 8", variants: ["Pixel 8", "Pixel 8 Pro"] },
        { name: "Pixel 7", variants: ["Pixel 7", "Pixel 7 Pro"] },
      ],
    },
    {
      manufacturer: "Motorola",
      models: [
        { name: "Moto Edge 40", variants: ["Edge 40", "Edge 40 Pro"] },
        { name: "Moto G73", variants: ["G73 5G"] },
        { name: "Moto Razr", variants: ["Razr 40", "Razr 40 Ultra"] },
      ],
    },
    {
      manufacturer: "Nothing",
      models: [
        { name: "Nothing Phone (2)", variants: ["Nothing Phone (2)"] },
        { name: "Nothing Phone (1)", variants: ["Nothing Phone (1)"] },
      ],
    },
    {
      manufacturer: "Asus",
      models: [
        {
          name: "Asus ROG Phone 7",
          variants: ["ROG Phone 7", "ROG Phone 7 Ultimate"],
        },
        { name: "Asus ZenFone 9", variants: ["ZenFone 9"] },
      ],
    },
    {
      manufacturer: "Infinix",
      models: [
        { name: "Infinix Zero Ultra", variants: ["Zero Ultra"] },
        { name: "Infinix Note 12", variants: ["Note 12 5G"] },
      ],
    },
    {
      manufacturer: "Tecno",
      models: [
        { name: "Tecno Pova 5", variants: ["Pova 5", "Pova 5 Pro"] },
        { name: "Tecno Camon 19", variants: ["Camon 19 Pro", "Camon 19 Neo"] },
      ],
    },
    {
      manufacturer: "Lava",
      models: [
        { name: "Lava Agni 2", variants: ["Agni 2 5G"] },
        { name: "Lava Blaze 5G", variants: ["Blaze 5G"] },
      ],
    },
    {
      manufacturer: "Micromax",
      models: [
        { name: "Micromax IN Note 2", variants: ["IN Note 2"] },
        { name: "Micromax IN 2b", variants: ["IN 2b"] },
      ],
    },
    {
      manufacturer: "Nokia",
      models: [
        { name: "Nokia X30 5G", variants: ["X30 5G"] },
        { name: "Nokia G60 5G", variants: ["G60 5G"] },
      ],
    },
    {
      manufacturer: "Lenovo",
      models: [
        { name: "Lenovo Legion Phone Duel 2", variants: ["Duel 2"] },
        { name: "Lenovo K13", variants: ["K13 5G"] },
      ],
    },
    {
      manufacturer: "Honor",
      models: [
        { name: "Honor 90", variants: ["90", "90 5G"] },
        { name: "Honor X8", variants: ["X8 5G"] },
      ],
    },
    {
      manufacturer: "Huawei",
      models: [
        { name: "Huawei P60 Pro", variants: ["P60 Pro"] },
        { name: "Huawei Mate 50 Pro", variants: ["Mate 50 Pro"] },
      ],
    },
    {
      manufacturer: "Sony",
      models: [
        { name: "Sony Xperia 1 IV", variants: ["Xperia 1 IV"] },
        { name: "Sony Xperia 10 IV", variants: ["Xperia 10 IV"] },
      ],
    },
  ];

  const laptopData = [
    {
      manufacturer: "Dell",
      models: [
        {
          name: "Inspiron 15",
          variants: ["Intel i5", "Intel i7", "AMD Ryzen 5", "AMD Ryzen 7"],
        },
        { name: "XPS 13", variants: ["Intel i5", "Intel i7", "Intel i9"] },
        { name: "Alienware X17", variants: ["Intel i7", "Intel i9"] },
      ],
    },
    {
      manufacturer: "HP",
      models: [
        {
          name: "Pavilion x360",
          variants: ["Intel i5", "Intel i7", "Intel i3"],
        },
        { name: "Envy 14", variants: ["Intel i5", "Intel i7"] },
        { name: "Omen 16", variants: ["Intel i7", "Intel i9", "AMD Ryzen 7"] },
      ],
    },
    {
      manufacturer: "Apple",
      models: [
        { name: "MacBook Air", variants: ["M2 Chip", "M1 Chip"] },
        { name: "MacBook Pro 13", variants: ["M2 Chip", "M1 Chip"] },
        { name: "MacBook Pro 16", variants: ["M1 Pro", "M1 Max"] },
      ],
    },
    {
      manufacturer: "Lenovo",
      models: [
        {
          name: "ThinkPad X1 Carbon",
          variants: ["Intel i5", "Intel i7", "Intel i9"],
        },
        { name: "Legion 5", variants: ["Intel i7", "AMD Ryzen 7"] },
        { name: "Yoga 9i", variants: ["Intel i5", "Intel i7", "Intel i9"] },
      ],
    },
    {
      manufacturer: "Asus",
      models: [
        {
          name: "ZenBook 14",
          variants: ["Intel i5", "Intel i7", "AMD Ryzen 5"],
        },
        { name: "ROG Zephyrus G14", variants: ["AMD Ryzen 9", "Intel i7"] },
        {
          name: "VivoBook 15",
          variants: ["Intel i3", "Intel i5", "Intel i7"],
        },
      ],
    },
    {
      manufacturer: "Acer",
      models: [
        {
          name: "Aspire 5",
          variants: ["Intel i5", "Intel i7", "AMD Ryzen 5"],
        },
        {
          name: "Predator Helios 300",
          variants: ["Intel i7", "Intel i9", "NVIDIA GTX 1660 Ti"],
        },
        { name: "Swift 3", variants: ["Intel i5", "Intel i7"] },
      ],
    },
    {
      manufacturer: "Microsoft",
      models: [
        { name: "Surface Laptop 5", variants: ["Intel i5", "Intel i7"] },
        {
          name: "Surface Pro 9",
          variants: ["Intel i5", "Intel i7", "Microsoft SQ3"],
        },
        {
          name: "Surface Book 3",
          variants: ["Intel i5", "Intel i7", "NVIDIA GTX 1650"],
        },
      ],
    },
  ];

  // const mobileManufacturers = [
  //   "Apple",
  //   "Samsung",
  //   "OnePlus",
  //   "Xiaomi",
  //   "Realme",
  //   "Oppo",
  //   "Vivo",
  //   "Google",
  //   "Motorola",
  //   "Nothing",
  //   "Asus",
  //   "Infinix",
  //   "Tecno",
  //   "Lava",
  //   "Micromax",
  //   "Nokia",
  //   "Lenovo",
  //   "Honor",
  //   "Huawei",
  //   "Sony",
  // ];

  const laptopManufacturers = [
    "Apple",
    "Dell",
    "HP",
    "Lenovo",
    "Asus",
    "Acer",
    "Microsoft",
  ];

  const documentTypes = ["Invoice", "Purchase Receipt", "Warranty Card"];

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));

    if (name === "pincode" && value.length === 6 && isValidPincode(value)) {
      try {
        const response = await fetch(
          `https://api.postalpincode.in/pincode/${value}`
        );
        const data = await response.json();
        if (data[0].Status === "Success") {
          const postOffice = data[0].PostOffice[0];
          setFormData((prev) => ({
            ...prev,
            city: postOffice.District,
            state: postOffice.State,
          }));
          setIsPincodeValid(true);
        } else {
          setFormData((prev) => ({
            ...prev,
            city: "",
            state: "",
          }));
          setIsPincodeValid(false);
        }
      } catch (error) {
        console.error("Pincode API error", error);
        setIsPincodeValid(false);
      }
    } else if (name === "pincode") {
      setFormData((prev) => ({
        ...prev,
        city: "",
        state: "",
      }));
      setIsPincodeValid(false);
    }
  };

  const isValidPincode = (pin) => {
    return /^[1-9][0-9]{5}$/.test(pin);
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    setSelectedManufacturer("");
    setModels([]);
    setVariants([]);

    setFormData({
      ...formData,
      gadgetModel: "",
      gadgetVariant: "",
    });
  };

  const handleManufactureChange = (e) => {
    const manufacturer = e.target.value;
    setSelectedManufacturer(manufacturer);

    setFormData({
      ...formData,
      gadgetModel: "",
      gadgetVariant: "",
    });

    const dataSource = selectedCategory === "mobile" ? mobileData : laptopData;
    const matchedItem = dataSource.find(
      (item) => item.manufacturer === manufacturer
    );

    if (matchedItem) {
      setModels(matchedItem.models);
      setVariants([]);
    } else {
      setModels([]);
      setVariants([]);
    }
  };

  const handleModelChange = (e) => {
    const modelName = e.target.value;

    setFormData({
      ...formData,
      gadgetModel: modelName,
      gadgetVariant: "",
    });

    const dataSource = selectedCategory === "mobile" ? mobileData : laptopData;
    const manufacturer = dataSource.find(
      (item) => item.manufacturer === selectedManufacturer
    );

    if (manufacturer) {
      const model = manufacturer.models.find((m) => m.name === modelName);
      if (model && model.variants) {
        setVariants(model.variants);
      } else {
        setVariants([]);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      pincode: "",
      city: "",
      state: "",
      panDetails: "",
      insurer: "",
      gadgetModel: "",
      gadgetVariant: "",
      uniqueIdentifier: "",
      documentType: "",
      termsAccepted: false,
    });
    setSelectedCategory("");
    setSelectedManufacturer("");
    setModels([]);
    setVariants([]);
    setValidated(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isEmptyField = Object.entries(formData).some(([key, value]) => {
      if (key === "termsAccepted") return false;
      return !value;
    });

    if (isEmptyField) {
      alert("Please fill in all required fields.");
      return;
    }

    console.log("Form submitted:", formData);
  };

  const handleClick = () => {
    if (typeof listener === "function") {
      listener();
    }
  };

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Puducherry",
    "Chandigarh",
    "Andaman and Nicobar Islands",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
  ];

  return (
    <>
      <Navbar />
      <div className="row justify-content-center align-items-center text-center">
        <div
          className="position-absolute start-0 w-100 h-100"
          style={{
            background:
              "radial-gradient(circle at top right, #A0FFFFCC 22%, transparent 88px)",
            filter: "blur(88px)",
            zIndex: 0,
            // marginTop:'-12%'
          }}
        ></div>

        <div className="col-12 pt-lg-5">
          <h2 className="fw-semibold carloan-text mb-3 mt-lg-5 ">
            Gadget Insurance
          </h2>
        </div>
        <Card.Header className="text-secondary d-flex justify-content-center align-items-center rounded-4">
          <h5 className="text-center px-2 px-md-5 fs-6 mb-5">
            To apply for a Gadget Insurance, <br /> please fill the details
            below
          </h5>
        </Card.Header>
      </div>
      <section
        className="insurance-service position-relative overflow-hidden"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 1) 40%, #F5F2FF 100%, rgba(255, 255, 255, 1) 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container className=" rounded-4 mb-5">
          <Card className="border-0 rounded-5 ">
            <Card.Body className="bg-light rounded-5">
              {showSuccess && (
                <Alert
                  variant="success"
                  onClose={() => setShowSuccess(false)}
                  dismissible
                >
                  Your application has been submitted successfully!
                </Alert>
              )}

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Card className="mb-3 mt-4 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3 mt-4">Personal details</h5>
                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="fullName">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name (as per PAN Card)"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your full name.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="mobileNumber">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            type="tel"
                            placeholder="OTP will be sent after you click 'Apply'"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            pattern="[0-9]{10}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid 10-digit mobile number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="emailId">
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email ID"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="dateOfBirth">
                          <Form.Label>Date of Birth</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder="(dd/mm/yyyy)"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your date of birth.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="panDetails">
                          <Form.Label>PAN details</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter PAN number"
                            name="panDetails"
                            value={formData.panDetails}
                            onChange={handleChange}
                            pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid PAN number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="pincode">
                          <Form.Label>Pincode</Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                            isInvalid={validated && !isPincodeValid}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid 6-digit pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="city">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            readOnly
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            City will be auto-filled from pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="state">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            name="state"
                            value={formData.state}
                            readOnly
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            State will be auto-filled from pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="insurer">
                          <Form.Label>Insurer</Form.Label>
                          <Form.Select
                            name="insurer"
                            value={formData.insurer}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="ICICI Lombard General Insurance">
                              ICICI Lombard General Insurance
                            </option>
                            <option value="HDFC ERGO General Insurance">
                              HDFC ERGO General Insurance
                            </option>
                            <option value="Bajaj Allianz General Insurance">
                              Bajaj Allianz General Insurance
                            </option>
                            <option value="Tata AIG General Insurance">
                              Tata AIG General Insurance
                            </option>
                            <option value="Reliance General Insurance">
                              Reliance General Insurance
                            </option>
                            <option value="New India Assurance">
                              New India Assurance
                            </option>
                            <option value="United India Insurance">
                              United India Insurance
                            </option>
                            <option value="Oriental Insurance">
                              Oriental Insurance
                            </option>
                            <option value="SBI General Insurance">
                              SBI General Insurance
                            </option>
                            <option value="Kotak Mahindra General Insurance">
                              Kotak Mahindra General Insurance
                            </option>
                            <option value="Future Generali India Insurance">
                              Future Generali India Insurance
                            </option>
                            <option value="Bharti AXA General Insurance (now merged with ICICI Lombard)">
                              Bharti AXA General Insurance (now merged with
                              ICICI Lombard)
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a insurer.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="mb-2 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3">Gadget details</h5>
                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="categorySelect">
                          <Form.Label>Select Category</Form.Label>
                          <Form.Select
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            required
                          >
                            <option value="">Select Category</option>
                            <option value="mobile">Mobile</option>
                            <option value="laptop">Laptop</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="manufacturerSelect">
                          <Form.Label>Manufacturer</Form.Label>
                          <Form.Select
                            name="manufacturer"
                            value={selectedManufacturer}
                            onChange={handleManufactureChange}
                            required
                            disabled={!selectedCategory}
                          >
                            <option value="">Select Manufacturer</option>
                            {selectedCategory === "mobile" &&
                              mobileData.map((data, index) => (
                                <option key={index} value={data.manufacturer}>
                                  {data.manufacturer}
                                </option>
                              ))}
                            {selectedCategory === "laptop" &&
                              laptopManufacturers.map((manufacturer, index) => (
                                <option key={index} value={manufacturer}>
                                  {manufacturer}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="gadgetModel">
                          <Form.Label>
                            {selectedCategory === "laptop"
                              ? "Laptop Model"
                              : "Mobile Model"}
                          </Form.Label>
                          <Form.Select
                            name="gadgetModel"
                            value={formData.gadgetModel}
                            onChange={handleModelChange}
                            required
                            disabled={models.length === 0 || !selectedCategory}
                          >
                            <option value="">Select Model</option>
                            {models.map((model, index) => (
                              <option key={index} value={model.name || model}>
                                {model.name || model}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="gadgetVariant">
                          <Form.Label>
                            {selectedCategory === "laptop"
                              ? "Laptop Variant"
                              : "Mobile Variant"}
                          </Form.Label>
                          <Form.Select
                            name="gadgetVariant"
                            value={formData.gadgetVariant}
                            onChange={handleChange}
                            required
                            disabled={
                              variants.length === 0 || !selectedCategory
                            }
                          >
                            <option value="">Select Variant</option>
                            {variants.map((variant, index) => (
                              <option key={index} value={variant}>
                                {variant}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="uniqueIdentifier">
                          <Form.Label>Unique Identifier</Form.Label>
                          <Form.Select
                            name="uniqueIdentifier"
                            value={formData.uniqueIdentifier}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="IMEI Number1">IMEI Number1</option>
                            <option value="IMEI Number2">IMEI Number2</option>
                            <option value="Serial Number">Serial Number</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select an identifier.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="dateOfBirth">
                          <Form.Label>Gadget Registration Date</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder="(dd/mm/yyyy)"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your gadget registration date.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-1 mb-sm-2">
                      <Col md={4} className="mb-2 mb-md-0">
                        <Form.Group controlId="documentType">
                          <Form.Label>Select any one document</Form.Label>
                          <Form.Select
                            name="documentType"
                            value={formData.documentType}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            {documentTypes.map((doc, index) => (
                              <option key={index} value={doc}>
                                {doc}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a document type.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                  <Row className="mb-1 mb-sm-2">
                  <Col>
                    <Form.Group controlId="termsAccepted">
                      <Form.Check
                        type="checkbox"
                        name="termsAccepted"
                        checked={formData.termsAccepted}
                        onChange={handleChange}
                        label={
                          <span>
                            By submitting the application, I agree and accept
                            the Terms and Conditions as specified{" "}
                            <a href="/" className="text-primary">
                              here
                            </a>
                          </span>
                        }
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        You must agree to the terms and conditions.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-3">
                  <Button
                    variant="primary"
                    type="submit"
                    className="px-4 py-2 "
                  >
                    Apply
                  </Button>
                  <Button
                    variant="outline-light bg-primary text-white px-4 py-2 "
                    onClick={resetForm}
                  >
                    Clear
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default Gadget;
